<template>
  <base-modal
    :ref="modal.key"
    :title="modal.title"
    :show="open"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    :maxWidth="700"
  >
    <v-form class="mt-5">
      <v-text-field
        v-bind:label="$t('Title')"
        v-model="widgetTitle"
        @blur="editingWidgetTitle = false"
        @focus="editingWidgetTitle = true"
      ></v-text-field>

      <ColorPicker :label="$t('Color')" v-model="model.color" />

      <v-checkbox
        v-model="model.showOnExternalApps"
        v-bind:label="$t('ShowOnExternalApps')"
        dense
      ></v-checkbox>

            <BaseDualList
                :source="availableBaskets"
                :destination="model.filter"
                item-text="text"
                item-id="id"
                itemCondition="IsDisabled"
                iconCondition="mdi-alert"
                messageCondition="DisabledFolderWarn"
                @onChangeList="onBasketListChange"
            />
        </v-form>
    </base-modal>
</template>
<script>
import WidgetService from '@/services/WidgetService';
import WidgetSettings from '@/ecm/models/widget/basket/BasketSettings';
import WidgetType from '@/ecm/variables/WidgetType';
import ColorPicker from '@/components/widgets/ColorPicker';
import UserWidgetService from '@/services/UserWidgetService';

export default {
    components: { ColorPicker },
    data() {
        return {
            loadingBasketList: false,
            basketList: [],
            availableBaskets: [],
            id: 0,
            model: new WidgetSettings(),
            modal: {
                title: this.$t('Settings'),
                key: 'userModal',
            },
            open: false,
            editingWidgetTitle: false,
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        widgetTitle: {
            get() {
                if (!this.editingWidgetTitle && !this.model.widgetTitle) {
                    return this.$t('Baskets');
                }
                return this.model.widgetTitle;
            },
            set(val) {
                this.model.widgetTitle = val;
            },
        },
    },
    methods: {
        async save() {
            this.modalInstance.progress(true);

            const model = Object.assign(new WidgetSettings(), this.model);

            const widgetDto = {
                Id: this.id,
                WidgetID: WidgetType.Baskets,
                Settings: model.toDto(),
            };

            UserWidgetService.updateSettings(widgetDto)
                .then(() => {
                    this.open = false;
                    this.$emit('on-save', model.toDto());
                })
                .catch(() => {
                    // error
                })
                .then(() => {
                    //always
                    this.modalInstance.progress(false);
                });
        },
        show(id, dto) {
            this.id = id;
            this.model = new WidgetSettings(dto);
            this.loadData();
            this.open = true;
        },
        hide() {
            this.open = false;
        },
        loadData() {
            this.loadBasketList(this.model.filter);
        },
        onBasketListChange: function({ destination, source }) {
            this.availableBaskets = source;
            this.model.filter = destination;
        },
        loadBasketList(filter) {
            this.loadingBasketList = true;
            WidgetService.getData({
                WidgetID: WidgetType.Baskets,
            }).then((data) => {
                this.basketList = data.map((d) => {
                    return {
                        id: Number(d.Id),
                        text: d.Description,
                        IsDisabled: d.IsDisabled,
                    };
                });
                const filteredBasketList = filter.filter((item) =>
                    this.basketList.some((basketItem) => basketItem.id === Number(item.id))
                );

                this.model = { ...this.model, filter: filteredBasketList };

                let availableBaskets = [...this.basketList];

                for (let i = 0; i < this.model.filter.length; i++) {
                    const selected = this.basketList.find(
                        (b) => b.id == this.model.filter[i].id
                    );

                    if (selected) {
                        this.model.filter[i].text = selected.text;
                        this.model.filter[i].IsDisabled = selected.IsDisabled;
                        availableBaskets = availableBaskets.filter((x) => {
                            return x.id !== selected.id;
                        });
                    }
                }
                this.availableBaskets = availableBaskets;
                this.loadingBasketList = false;
            });
        },
    },
};
</script>
